import React from 'react';
import './user-role-header.scss';
import ProfileDropdown from '../../../compound/ProfileDropdown';
import Logo from '../../../../assets/images/logo.svg';

const UserRoleTopHeader = () => {
  return (
    <header className="user-role-top-header">
        <div className="user-role-top-header__container">
            <div className="user-role-top-header__left">
               <img src={Logo} alt="logo" />
            </div>
            <div className="user-role-top-right">
            <ProfileDropdown />
            </div>
        </div>
    </header>
  )
}
export default UserRoleTopHeader;